export function splitName(name) {
  const names = (name || '').trim().split(' ');
  const lastName = (names.pop() || '').trim();
  const firstName = (names.join(' ') || '').trim();

  return { firstName, lastName };
}
